import { TranscricaoState, TranscricaoStepEnum } from './types';

export const defaultTranscricaoState: TranscricaoState = {
  currentStep: TranscricaoStepEnum.Anexos,
  anexos: [],
  validandoAnexo: false,
  termosAceitos: false,
  dataAceite: null,
  idTranscricao: null,
  origemRevisao: null,
  revisaoStatus: 'idle',
  procedimentos: [],
  detalheTranscricao: null,
};
